/**
 * @description create a regex from a string
 * @author liuchuan
 */
export const createRegexFromString = (pattern: string, flags?: string) =>
  new RegExp(`${pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, flags);
